import React, { RefObject, useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { api } from "../api/client";
import { MenuIcon } from "../pages/Dashboard/MenuIcon";
import { humanRole, navigationGroups } from "./navigation";

export function Navigation({ listRef, onNavigate }: { listRef: RefObject<HTMLUListElement | null>; onNavigate: () => void }) {
    const [profile, setProfile] = useState<{ name?: string; primaryRole?: string; avatarUrl?: string } | null>(null);
    useEffect(() => {
        const controller = new AbortController();
        api.get<typeof profile>("/api/me", undefined, { signal: controller.signal })
            .then(value => { if (!controller.signal.aborted) setProfile(value); })
            .catch(() => {});
        return () => controller.abort();
    }, []);
    const initials = (profile?.name || "Франчайзи").split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join("");
    return <>
        <Link to="/" className="lkfr-brand" onClick={onNavigate} aria-label="Чио Чио — главная">
            <span className="lkfr-brand-mark">чио<span>чио</span></span>
            <span className="lkfr-brand-caption">Кабинет франчайзи</span>
        </Link>
        <nav className="lkfr-navigation" aria-label="Разделы кабинета">
            <ul ref={listRef}>
                {navigationGroups.map(group => <li className="lkfr-nav-group" key={group.label}>
                    <span className="lkfr-nav-group-label">{group.label}</span>
                    {group.items.map(item => item.external
                        ? <a className="lkfr-nav-link" key={item.href} href={item.href} target="_blank" rel="noopener noreferrer" onClick={onNavigate}><MenuIcon name={item.icon} /><span>{item.label}</span><small aria-label="В новой вкладке">↗</small></a>
                        : <NavLink className={({ isActive }) => `lkfr-nav-link${isActive ? " active" : ""}`} key={item.href} to={item.href} end={item.end} onClick={onNavigate}><MenuIcon name={item.icon} /><span>{item.label}</span></NavLink>)}
                </li>)}
            </ul>
        </nav>
        <Link to="/profile" onClick={onNavigate} className="lkfr-nav-profile">
            {profile?.avatarUrl ? <img src={profile.avatarUrl} alt="" /> : <span className="lkfr-avatar">{initials}</span>}
            <span><strong>{profile?.name || "Мой профиль"}</strong><small>{humanRole(profile?.primaryRole)}</small></span><span aria-hidden="true">›</span>
        </Link>
    </>;
}
